export default __webpack_public_path__ + "static/media/assets-book-articles.7617a43e.png";